<template>
  <div class="wg-limits">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text">Продажи и остатки дилера</v-card-title>
          <v-card-text
            v-if="!loading && limits && limits.length"
            class="dashboard__card-text pa-0">
            <v-expansion-panels class="mb-6" focusable>
              <v-expansion-panel
                v-for="(item, i) in limits"
                :key="i"
              >
                <v-expansion-panel-header
                  expand-icon="mdi-menu-down"
                >
                  <div class="wg-limits__header">
                    <div class="wg-limits__title">{{item.label}}</div>
                    <div class="wg-limits__sum">В остатке у дилера: {{item.balance}}</div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="wg-limits__content">


                  <div class="h-table h-table--w6 wg-limits__table">
                    <div class="h-table__thead">
                      <div class="h-table__tr">
                        <div class="h-table__th wg-limits__table-th wg-limits__table-th--date">Дата</div>
                        <div class="h-table__th wg-limits__table-th wg-limits__table-th--manager">Менеджер</div>
                        <div class="h-table__th wg-limits__table-th wg-limits__table-th--category">Категория</div>
                        <div class="h-table__th wg-limits__table-th wg-limits__table-th--qty">Количество</div>
                      </div>
                    </div>
                    <div class="h-table__tbody">
                      <div
                        class="h-table__tr wg-limits__table-tr"
                        v-for="(i, idx) in item.items"
                        :key="idx"
                      >
                        <div class="h-table__td wg-limits__table-td wg-limits__table-td--date wg-limits__table-td--first">
                          <div class="wg-limits__table-td-header">Дата</div>
                          <div class="wg-limits__table-td-content">{{i[0]}}</div>
                        </div>
                        <div class="h-table__td wg-limits__table-td wg-limits__table-td--manager">
                          <div class="wg-limits__table-td-header">Менеджер</div>
                          <div class="wg-limits__table-td-content">{{i[1]}}</div>
                        </div>
                        <div class="h-table__td wg-limits__table-td wg-limits__table-td--category">
                          <div class="wg-limits__table-td-header">Категория</div>
                          <div class="wg-limits__table-td-content">{{i[2]}}</div>
                        </div>
                        <div class="h-table__td wg-limits__table-td wg-limits__table-td--qty">
                          <div class="wg-limits__table-td-header">Количество</div>
                          <div class="wg-limits__table-td-content">{{i[3]}}</div>
                        </div>
                      </div>
                    </div>
                  </div>


                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-text class="pa-5 text-center" v-if="loading">
            <v-progress-circular
              :width="3"
              color="#0075a8"
              indeterminate
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="pt-3" v-if="!loading && !limits.length">
            <p>Список лимитов пуст...</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['limits', 'loading'],
  methods: {},
};
</script>

<style lang="scss">
@use '../../assets/scss/variables';

.wg-limits {
  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 20px;
  }
  &__content {
    padding-top: 30px;

    @media (min-width: 600px) {
      padding-top: 0;
    }
  }

  &__table-tr {
    @media (max-width: 600px) {
      border: 1px solid variables.$wg-rating-table-border-color;
      padding: 6px;
      margin-bottom: 30px;
    }
  }
  &__table-th {
    display: none;
    border-right: 1px solid variables.$wg-rating-table-border-color;
    color: variables.$wg-rating-table-header-color;
    font-size: 14px;

    @media (min-width: 600px) {
      display: table-cell;
      padding: 4px;
    }

    &:last-child {
      border-right: none;
    }

    &--date {
      width: 100px;
    }
    &--qty {
      text-align: right;
      width: 100px;
    }
  }
  &__table-td {
    border-top: 1px solid variables.$wg-rating-table-border-color;
    border-right: 1px solid variables.$wg-rating-table-border-color;
    padding: 4px;
    font-size: 12px;

    @media (max-width: 600px) {
      display: flex;
      justify-content: space-between;
      border-right: none;
      border-top: 1px dotted variables.$wg-rating-table-border-color;
    }

    &:last-child {
      border-right: none;
    }

    &--first {
      @media (max-width: 600px) {
        border-top: none;
      }
    }
    &--qty {
      text-align: right;
    }
  }
  &__table-td-header {
    padding-right: 4px;
    color: variables.$wg-rating-table-header-color;

    @media (min-width: 600px) {
      display: none;
    }
  }
}
</style>
